import { EmptyGuid } from "../emptyGuid";
import { luscinia } from "../luscinia";
import { PageStateConstructor } from "./PageStateConstructor";

export default function postPageState() {
    const pageStateConstructor = new PageStateConstructor();
    const pageState = pageStateConstructor.construct();
    const bootgrid = $("table.luscinia-bootgrid").first();
    if ((bootgrid as any).data(luscinia.data.menuItemId) !== EmptyGuid.value) {
        $.ajax({
            type: "POST",
            url: bootgrid.data(luscinia.data.baseUrl) + "/bootgridsettings/" + bootgrid.data(luscinia.data.menuItemId),
            dataType: "json",
            data: JSON.stringify(pageState),
            success: function (data) { },
        });
    }
}
